var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import { Address } from "nem-library";
import MessageDialog from '../../parts/MessageDialog.vue';
import { MUTATION_TYPES } from '../../../lib/mutationTypes';
import { getAccountHttp } from "../../../lib/nisUtils";
import { WalletsHelper } from "../../../lib/storage";
import MessageModule from "../../mixins/MessageModule";
export default Vue.extend({
    mixins: [MessageModule],
    components: { MessageDialog },
    name: "SendView",
    data() {
        return {
            address: "",
            showNewbieCaution: false,
        };
    },
    methods: {
        onClickedOk() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!(yield WalletsHelper.getActive())) {
                    this.showError(this.$t('wallet.not_select_message').toString());
                    return;
                }
                const accountHttp = getAccountHttp();
                let address;
                try {
                    address = new Address(this.address);
                }
                catch (_a) {
                    this.showError(this.$t('common.invalid_address').toString());
                    return;
                }
                this.$store.commit(MUTATION_TYPES.SET_RECEIVER_ADDRESS, this.address);
                // check the address is newbie
                accountHttp.getFromAddress(address).subscribe(accountInfoWithMetaData => {
                    if (accountInfoWithMetaData.publicAccount.hasPublicKey()) {
                        // store public key for message encryption
                        this.$store.commit(MUTATION_TYPES.SET_RECEIVER_PUBLIC_KEY, accountInfoWithMetaData.publicAccount.publicKey);
                    }
                    else {
                        this.$store.commit(MUTATION_TYPES.SET_RECEIVER_PUBLIC_KEY, '');
                    }
                    this.$store.commit(MUTATION_TYPES.CLEAR_SEND_MOSAIC);
                    this.$router.push('/send/amount');
                }, error => {
                    this.showNewbieCaution = true;
                });
            });
        },
        onClosedNewbieCaution() {
            this.$store.commit(MUTATION_TYPES.CLEAR_SEND_MOSAIC);
            this.$router.push('/send/amount');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/top/Send.vue
// module id = 604
// module chunks = 1